module.exports = __webpack_public_path__ + "static/media/que-hacer-en-palermo.93c2b03a.md";